// extracted by mini-css-extract-plugin
module.exports = {"quantity":"QuantitySelector_quantity__YOPe2","pdp-quantity":"QuantitySelector_pdp-quantity__20MZT"};